import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";

/**
 * Normalise an external ad link so the browser doesn't treat values like
 * "www.example.com" as relative paths (which would resolve to
 * `https://sine81.com/www.example.com`).
 *  - Absolute http(s) URLs are returned as-is.
 *  - Internal paths starting with "/" are returned as-is.
 *  - tel:/mailto: are returned as-is.
 *  - Everything else (e.g. "www.example.com", "example.com/page") gets
 *    `https://` prepended.
 */
export function normaliseExternalUrl(raw) {
  if (!raw) return "#";
  const s = String(raw).trim();
  if (!s) return "#";
  if (s === "#") return "#";
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith("/") || s.startsWith("#")) return s;
  if (/^(tel:|mailto:|sms:|whatsapp:|geo:)/i.test(s)) return s;
  // Treat everything else as an external host shorthand.
  return `https://${s.replace(/^\/+/, "")}`;
}

export default function AdBanner({ slug = "top-banner", className = "" }) {
  const { selected } = useProvince();
  const [ad, setAd] = useState(null);
  useEffect(() => {
    api.get(`/ads?zone_slug=${slug}${selected ? `&province_id=${selected.id}` : ""}&limit=1`).then((r) => {
      if (r.data?.length) {
        setAd(r.data[0]);
        api.post(`/ads/${r.data[0].id}/impression`).catch(() => {});
      }
    }).catch(() => {});
  }, [selected?.id, slug]);
  if (!ad) {
    return (
      <a href="/kurumsal/reklam" className={`block ${className}`}>
        <div className="w-full bg-gradient-to-r from-gray-100 to-gray-50 border border-dashed border-gray-300 text-gray-500 text-xs flex items-center justify-center rounded-md" style={{ minHeight: 70 }}>
          REKLAM ALANI — sine81.com/reklam
        </div>
      </a>
    );
  }
  const handleClick = () => api.post(`/ads/${ad.id}/click`).catch(() => {});
  const safeHref = normaliseExternalUrl(ad.link);
  return (
    <a
      href={safeHref}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={`block ${className}`}
      data-testid={`ad-banner-${slug}`}
    >
      <img src={ad.image} alt={ad.name} className="w-full h-auto rounded-md" />
    </a>
  );
}
